import {BoisType} from '@/models';

export default [
	{
		path: '/essences',
		name: 'essences',
		meta: {
			title: 'Liste des essences',
			granted: [ 'API_GET_BOISTYPE' ]
		},
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/BoisType.vue')
	},
	{
		path: '/boisType/edit/:id',
		name: 'boisType-edit',
		props: {
			slotData: () => ({
				component: import(/* webpackChunkName: "dashboard" */ '../components/Crud/BoisType/Edit.vue'),
				class: BoisType
			}),
		},
		meta: {
			title: 'Edition d\'une essence',
			granted: [ 'API_PUT_BOISTYPE' ]
		},
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/EditShow.vue')
	},
];